export default "__VITE_ASSET__DM15jBIT__"